/**
 * @generated SignedSource<<587c3e117e71e561ba1da6533410ed33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cmsSpecialtyId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "practitionerLocationCmsSpecialtyId"
},
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "cmsSpecialtyId",
        "variableName": "cmsSpecialtyId"
      },
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "practitionerLocationCmsSpecialtyId",
        "variableName": "practitionerLocationCmsSpecialtyId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveFrom",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveTo",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPractitionerLocationCmsSpecialtyModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PractitionerLocationMutationGroup",
        "kind": "LinkedField",
        "name": "practitionerLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "PractitionerLocationCmsSpecialtyModifyPayload",
            "kind": "LinkedField",
            "name": "modifyCmsSpecialty",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerLocationCmsSpecialty",
                "kind": "LinkedField",
                "name": "practitionerLocationCmsSpecialty",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CmsSpecialty",
                    "kind": "LinkedField",
                    "name": "cmsSpecialty",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CmsSpecialtyVersion",
                        "kind": "LinkedField",
                        "name": "applicableVersion",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditPractitionerLocationCmsSpecialtyModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PractitionerLocationMutationGroup",
        "kind": "LinkedField",
        "name": "practitionerLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "PractitionerLocationCmsSpecialtyModifyPayload",
            "kind": "LinkedField",
            "name": "modifyCmsSpecialty",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PractitionerLocationCmsSpecialty",
                "kind": "LinkedField",
                "name": "practitionerLocationCmsSpecialty",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CmsSpecialty",
                    "kind": "LinkedField",
                    "name": "cmsSpecialty",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CmsSpecialtyVersion",
                        "kind": "LinkedField",
                        "name": "applicableVersion",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "128311ea5e525a17f44f142721762e38",
    "id": null,
    "metadata": {},
    "name": "EditPractitionerLocationCmsSpecialtyModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditPractitionerLocationCmsSpecialtyModalMutation(\n  $practitionerLocationCmsSpecialtyId: ID!\n  $cmsSpecialtyId: ID!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  practitionerLocation {\n    modifyCmsSpecialty(input: {practitionerLocationCmsSpecialtyId: $practitionerLocationCmsSpecialtyId, cmsSpecialtyId: $cmsSpecialtyId, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      practitionerLocationCmsSpecialty {\n        id\n        cmsSpecialty {\n          applicableVersion {\n            name\n            id\n          }\n          id\n        }\n        effectiveFrom\n        effectiveTo\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "fec78abbfa1afd3e24d7793d19aaaf18";

export default node;
